import { createSlice } from "@reduxjs/toolkit";

const analyzeSlice = createSlice({
  name: 'analyze',
  initialState: {
    keyNumbers: [],
  },
  reducers: {
    updateKeyNumbers: (state, action) => {
      state.keyNumbers = action.payload;
    },
  },
});

export default analyzeSlice;
